export const MAX_CELSIUS_TEMP = 230;
export const MIN_CELSIUS_TEMP = 40;

export const TEMPERATURE_OVERFLOW_THRESHOLD = 6536;

export const DEGREE_SYMBOL = "\u00B0";
